module.exports = __webpack_public_path__ + "static/media/poppins-v20-latin-regular.f8ed3280.woff";